<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <span style="margin-top: 5px">{{ title }}</span>
        <v-fade-transition>
           <span style="display: inline-flex" v-if="open">
              <v-divider class="mx-2" vertical/>
              <v-menu
                :absolute="false"
                :close-on-click="true"
                :close-on-content-click="true"
                :offset-y="true"
              >
                  <template v-slot:activator="{ on }">
                      <v-btn v-on="on" small color="primary" @click="row_create()">
                        Add <v-icon class="ml-2" x-small>mdi-text-box</v-icon>
                      </v-btn>
                  </template>
                  <v-list v-for="(item,i) in items" :key="i" dense class="pa-0">
                      <v-list-item dense>
                          <v-list-item-title v-text="item.platform.kind.key"/>
                      </v-list-item>
                  </v-list>
              </v-menu>
           </span>
        </v-fade-transition>
        <v-spacer/>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider class="mb-2"/>
      <v-chip
        v-for="(item,i) in items"
        :key="i"
        class="ma-1"
        :color="item.visible ? 'green':'blue darken-1'"
        :outlined="!item.visible"
        :text-color="item.visible ? 'white':'blue'"
        close
        @click="row_update(item)"
        @click:close="row_remove(item)"
      >
        {{ item.platform.kind.key }}
      </v-chip>
    </v-expansion-panel-content>

    <r-trigger-wonder ref="trigger"/>
  </v-expansion-panel>
</template>

<script>

import VueTypes from "vue-types";

import {ViewRules} from "@/common/ViewRules";

import RTriggerWonder from "@/modules/redactor/views/trigger/r-trigger-wonder";
import  {WorldRegionWonderModel}  from "@/modules/redactor/models/world-region/wonder/WorldRegionWonderModel";


export default {
  name: "r-wonders-panel",
  components: {
    RTriggerWonder
  },
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(WorldRegionWonderModel),
  },
  computed: {
  },
  methods: {
    row_create() {
      this.$refs["trigger"].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(trigger) {
      this.$refs["trigger"].show(ViewRules.UPDATE, trigger.clone())
          .then((data) => {
            const index = this.items.indexOf(trigger);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(trigger) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(trigger);
        this.items.splice(index, 1);
      });
    }
  }
}

</script>
